'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _memoize = require('lodash/memoize');

var _memoize2 = _interopRequireDefault(_memoize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function isNil(value) {
  return value === undefined || value === null;
}
function sallowCopy(obj) {
  return Array.isArray(obj) ? [].concat(_toConsumableArray(obj)) : _extends({}, obj);
}
function toUpdateFunc(input) {
  return typeof input === 'function' ? input : function () {
    return input;
  };
}

/**
 * Creates a partial-updater function that updates a part of the value
 * that `updater` will update. Updater is a function receiving a new value
 * or a function returns a new value to update the value.
 *
 * @param  {string} key The key of the value to update by the sub-updater
 * @param  {Function} updater The function to update a value
 * @return {Function} Returns a function, only update a part of the value
 */
// export default function splitUpdater (key, updater, emptyObj = { }) {
// const splitUpdater = (key, updater, emptyObj = { }) => {
var splitUpdater = function splitUpdater(updater) {
  return function (key) {
    var emptyObj = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    // Creates a function that updates a part of value by a newValue or
    // a function recevies old obj and returns a new obj
    return function partialUpdater(input, callback) {
      return updater(function (obj) {
        return Object.assign(
        // Creates or clones an object for updating
        isNil(obj) ? emptyObj : sallowCopy(obj),
        // An object with new partial value
        _defineProperty({}, key, toUpdateFunc(input)(obj && obj[key])));
      }, callback);
    };
  };
};

// cache updater with WeakMap, cache key with default Map
// when call `memoize(splitUpdater(updater))`,
// the `memoize.Cache` is `undefined`
_memoize2.default.Cache = WeakMap; // prevent memory leak
var memoizedSplitUpdater = (0, _memoize2.default)(function (updater) {
  return (0, _memoize2.default)(splitUpdater(updater));
});
_memoize2.default.Cache = undefined; // reset, use default Cache for other memoized funcs

exports.default = memoizedSplitUpdater;

/**
 * Trivial split updater function??
 */
// export default (updater, key, init = { }) => (val, callback) => updater(
//   (obj) => Object.assign(
//     isNil(obj) ? init : Array.isArray(obj) ? [...obj] : { ...obj },
//     { [key]: (typeof val === 'function' ? val : () => val)(obj && obj[key]) }
//   ),
//   callback
// )

/**
 *  Another implemntation for creating a partial update function
 *  It give a chance to check if new value is the same as old value
 *  Maybe not call updater if value not change?
 */
// (obj) => {
//   const updatedObj = isNil(obj) ? emptyObj : sallowCopy(obj)
//   updatedObj[key] = toUpdateFunc(input)(updatedObj[key])
//   return updatedObj
// },


//////////////////
// WEBPACK FOOTER
// ./~/coact-utils/splitUpdater.js
// module id = 1718
// module chunks = 0